import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resource } from '@util/resource';
import { EcommerceShop, EcommerceShopUpsert } from '@interfaces/dws/ecommerce-shop';

@Injectable({
  providedIn: 'root'
})
export class EcommerceShopsService {
  list(): Observable<EcommerceShop[]> {
    return resource('crm://ecommerce/shops').get<EcommerceShop[]>();
  }

  get(installationId: string): Observable<EcommerceShop> {
    return resource('crm://ecommerce/shops/id')
      .params({ id: installationId })
      .get<EcommerceShop>();
  }

  create(body: EcommerceShopUpsert): Observable<EcommerceShop> {
    return resource('crm://ecommerce/shops').post<EcommerceShop>(body);
  }

  update(installationId: string, body: EcommerceShopUpsert): Observable<EcommerceShop> {
    return resource('crm://ecommerce/shops/id')
      .params({ id: installationId })
      .put<EcommerceShop>(body);
  }

  duplicate(installationId: string): Observable<EcommerceShop> {
    return resource('crm://ecommerce/shops/id/duplicate')
      .params({ id: installationId })
      .post<EcommerceShop>();
  }

  delete(installationId: string): Observable<void> {
    return resource('crm://ecommerce/shops/id')
      .params({ id: installationId })
      .delete();
  }
}
